// Additive endpoints for the connected site-domain policy workflow.
const domainPolicyOperation = (organizationId, operationId) =>
  `/site-collections/organizations/${encodeURIComponent(organizationId)}/domain-policy-operations/${encodeURIComponent(operationId)}`;

export const ApiEndpoints = {
  siteCollections: '/site-collections',
  siteCollection: (id) => `/site-collections/${encodeURIComponent(id)}`,
  domainConfigurationState: (organizationId, siteCollectionId) =>
    `/site-collections/organizations/${encodeURIComponent(organizationId)}/${encodeURIComponent(siteCollectionId)}/domain-configuration-state`,
  extensionOrigins: (organizationId) => `/organizations/${encodeURIComponent(organizationId)}/extension/origins`,
  domainPolicyOperation,
  retryDomainPolicyOperation: (organizationId, operationId) => `${domainPolicyOperation(organizationId, operationId)}/retry`
};
